"use client";

import { usePublicPathname } from "@/app/hooks/use-public-pathname";
import { isBrandPath } from "@/app/config/brand-registry";

type FooterBrandVisibilityProps = {
  children: React.ReactNode;
  hideOnAudi?: boolean;
};

export default function FooterBrandVisibility({
  children,
  hideOnAudi = false,
}: FooterBrandVisibilityProps) {
  const pathname = usePublicPathname();
  const isAudiPath = isBrandPath(pathname, "audi");

  if (hideOnAudi && isAudiPath) {
    return null;
  }

  return <>{children}</>;
}
